import { abbreviateNumber } from "@/utils/numberUtils";

export const formatRevenueRange = (revenueRange: {
  min?: number | null;
  max?: number | null;
}): string => {
  const min = revenueRange?.min;
  const max = revenueRange?.max;

  const hasMin = min !== null && min !== undefined;
  const hasMax = max !== null && max !== undefined;

  if (hasMin && hasMax) {
    if (min === max) {
      return `$${abbreviateNumber(min)}`;
    }
    return `$${abbreviateNumber(min)} - $${abbreviateNumber(max)}`;
  } else if (hasMin) {
    return `Above $${abbreviateNumber(min)}`;
  } else if (hasMax) {
    return `Below $${abbreviateNumber(max)}`;
  }

  return "Unknown";
};
